import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { scheduledTransactionsHead } from "../../../../../config/constant";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";
import SearchText from '../../../../Shared/components/SearchText';
import { NavLink, Link } from "react-router-dom";
import moment from 'moment';
import { Image, Space, Dropdown, Menu } from "antd";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, roleManagement,
        loadMoreContent, loadMoreTask, search } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={scheduledTransactionsHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 0) }}>
                                                {
                                                    roleManagement !== '' && checkCRUDPermission(`Schedule Transactions`, 'view', 'Admin') ?
                                                        <Link style={{ width: getColumnWidth(scheduledTransactionsHead, 0) }} to={`/admin/batch-process/schedule-transactions/${data?.id}/view`}
                                                            className={clsx(classes.color, classes.wordBreak, classes.disBlock, classes.bold)}>
                                                            {data?.serial_no || '---'}</Link> :
                                                        <div style={{ width: getColumnWidth(scheduledTransactionsHead, 0) }} className={clsx(classes.positionRelative)}>{data?.serial_no || '---'}</div>
                                                }
                                            </TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 1) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 1) }}>{data?.customer?.name || '---'}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 2) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 2) }}>{moment(data?.schedule_date).format('DD MMM YYYY')}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 3) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 3) }}>{data?.createdBy || '---'}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 4) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 4) }}>{moment(data?.createTs).format('DD MMM YYYY')}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 5) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 5) }}>{moment(data?.createTs).format('hh:mm:ss')}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 6) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 6) }}>{data?.batch_automate ? 'Yes' : 'No'}</span></TableCell>
                                            <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(scheduledTransactionsHead, 7) }}><span style={{ width: getColumnWidth(scheduledTransactionsHead, 7) }}>{capitalizeFirstLetter(data?.schedule_status)}</span></TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission(`Schedule Transactions`, 'view', 'Admin') &&
                                                        <Link to={`/admin/batch-process/schedule-transactions/${data?.id}/view`}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </Link>
                                                    }
                                                    <Dropdown
                                                        trigger={['click']}
                                                        placement={'bottomRight'}
                                                        overlay={
                                                            <Menu className={clsx(classes.groupMenu)}>
                                                                <Menu.Item key={"Re-Schedule"}><NavLink to={'#'}>Re-Schedule</NavLink></Menu.Item>
                                                                <Menu.Item key={"Cancel"}><NavLink to={'#'}>Cancel</NavLink></Menu.Item>
                                                            </Menu>
                                                        }>
                                                        <Image
                                                            src={ElipsisIcon}
                                                            preview={false}
                                                        />
                                                    </Dropdown>
                                                </Space>
                                            </TableCell>

                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                    {
                                                        search !== '' ? <SearchText /> : <>No results found</>
                                                    }

                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}